"use client"

import type { AiRunSummary } from "@/modules/ai/evidence-contracts"

/** Only durable run/proposal state is shown, with no scripted or fabricated tool steps. */
export function AiRunStatus({ run, reviewRequired = false, assistantName = "DanAI" }: { run?: AiRunSummary; reviewRequired?: boolean; assistantName?: string }) {
  if (!run) return null
  const labels = { pending: `Queued for ${assistantName}`, running: `${assistantName} is checking the request and preparing a reply`, completed: "Reply ready", failed: `${assistantName} could not finish this reply`, discarded: "This reply was superseded by a newer request", cancelled: "Reply stopped" } as const
  return <div className="communication-ai-run" role="status" aria-live="polite" data-state={run.state}>
    <span>{run.state === "completed" && reviewRequired ? "Suggestion ready for your review" : labels[run.state]}</span>
    {run.state === "running" && <small>Nothing is applied without the required review.</small>}
  </div>
}
